module.exports = __webpack_public_path__ + "img/GR.5d13418c.svg";